/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExploreListResponse } from '../models/ExploreListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExploreService {
    /**
     * Explore
     * @param cursor
     * @returns ExploreListResponse Successful Response
     * @throws ApiError
     */
    public static exploreApiExploreGet(
        cursor?: (string | null),
    ): CancelablePromise<ExploreListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/explore/',
            query: {
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
